import type { MarketingConsent } from "./consent";

type Utm = Partial<Record<"source" | "medium" | "campaign" | "content" | "term", string>>;
type MarketingFields = {
  public_page_view: { pageViewId: string; canonicalPath: string; referrerClass: string; utm: Utm; consentState: "granted" };
  product_cta_impression: { pageViewId: string; ctaId: string; consentState: "granted"; transitionId?: string };
  product_cta_clicked: { pageViewId: string; ctaId: string; destinationHost: "app"; destinationPath: string; consentState: "granted"; transitionId?: string };
};
type MarketingEventName = keyof MarketingFields;
export type MarketingReporter = (event: string, parameters: Record<string, unknown>) => void;

export function emitMarketingEvent<E extends MarketingEventName>(
  event: E,
  fields: MarketingFields[E],
  options: {
    consent: MarketingConsent;
    artifactSha: string;
    report: MarketingReporter;
    uuid?: () => `${string}-${string}-${string}-${string}-${string}`;
    now?: () => Date;
  },
) {
  if (options.consent !== "granted") return null;
  if (!/^[0-9a-f]{64}$/.test(options.artifactSha)) throw new Error("A 64-character artifact SHA is required");
  const payload = {
    event,
    clientEventId: (options.uuid ?? (() => crypto.randomUUID()))(),
    occurredAt: (options.now ?? (() => new Date()))().toISOString(),
    host: "apex" as const,
    artifactSha: options.artifactSha,
    ...fields,
  };
  options.report(event, payload);
  return payload;
}
